import * as React from 'react';

// =============================================================================
// mentions-legales-screen.tsx — Mentions légales (route publique « /mentions-legales », §2.1).
// =============================================================================
// Page PUBLIQUE (pré-auth) atteinte depuis le footer de la landing (§2.1 l.562).
// Contenu légal statique (éditeur, publication). Aucune donnée métier, aucun appel
// réseau. Structure sémantique (WCAG 2.1 AA) : <h1>, sections titrées, <dl> pour les
// informations d'identité, lien tel: accessible.

export function MentionsLegalesScreen(): React.JSX.Element {
  return (
    <div className="mx-auto max-w-2xl space-y-8 py-4">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold tracking-tight text-foreground">
          Mentions légales
        </h1>
      </header>

      <section aria-labelledby="ml-editeur" className="space-y-3">
        <h2 id="ml-editeur" className="text-lg font-semibold text-foreground">
          Éditeur du site
        </h2>
        <dl className="space-y-2 text-sm text-muted-foreground">
          <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-2">
            <dt className="font-medium text-foreground sm:w-48">Raison sociale</dt>
            <dd>JEKO Achats et Transformation</dd>
          </div>
          <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-2">
            <dt className="font-medium text-foreground sm:w-48">Forme juridique</dt>
            <dd>SAS au capital de 1 000 euros</dd>
          </div>
          <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-2">
            <dt className="font-medium text-foreground sm:w-48">Siège social</dt>
            <dd>59650 Villeneuve-d&apos;Ascq</dd>
          </div>
          <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-2">
            <dt className="font-medium text-foreground sm:w-48">SIREN</dt>
            <dd>940 197 023</dd>
          </div>
          <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-2">
            <dt className="font-medium text-foreground sm:w-48">RCS</dt>
            <dd>Lille Métropole</dd>
          </div>
          <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-2">
            <dt className="font-medium text-foreground sm:w-48">Téléphone</dt>
            <dd>
              <a
                href="tel:+33695799768"
                className="rounded-sm underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
              >
                06 95 79 97 68
              </a>
            </dd>
          </div>
        </dl>
      </section>

      <section aria-labelledby="ml-publication" className="space-y-2">
        <h2 id="ml-publication" className="text-lg font-semibold text-foreground">
          Responsables de la publication
        </h2>
        <p className="text-sm text-muted-foreground">
          M. John Mocali et Mme Camille Magnier
        </p>
      </section>

      <p className="border-t border-border pt-4 text-sm text-muted-foreground">
        © 2025 JEKO Achats et Transformation. Tous droits réservés.
      </p>
    </div>
  );
}
